import axios from 'axios'

// 环境的切换
// if (process.env.NODE_ENV === 'development') {
//   axios.defaults.baseURL = '/'
// } else if (process.env.NODE_ENV === 'production') {
//   axios.defaults.baseURL = 'http://support.ti.qianxin.com'
// }

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // token && (config.headers.Authorization = token)
    return config;
  },
  error => {
    return Promise.error(error)
  })

axios.defaults.timeout = 10000

// axios请求头默认是application/json, 如果使用formData格式数据就打开这一行注释
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 响应拦截器
axios.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  }, error => {
    return Promise.reject(error.response)
  })

export default axios;
